import MessagesSidebar from './container'
export { MessagesSidebar }
export default MessagesSidebar